var exports = {
  "Q": "x0a7806d5--ee8e9e--text",
};

module.exports = exports;
